exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.card-header > p {\n    color: #58595b;\n}\n", "", {"version":3,"sources":["/app/src/pages/billing/Details.vue"],"names":[],"mappings":";AACA;IACI,eAAe;CAClB","file":"Details.vue","sourcesContent":["\n.card-header > p {\n    color: #58595b;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10177ab2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/billing/Details.vue
// module id = tAZB
// module chunks = 4